<template>
    <v-row class="my-2 d-flex align-center">
        <v-col cols="12" md="6">
            <v-skeleton-loader type="text" v-if="$store.state.loading"></v-skeleton-loader>
            <v-text-field v-else label="Rechercher une équipe" density="compact" hide-details v-model="search"
                color="secondary"></v-text-field>
        </v-col>
    </v-row>
</template>

<script>
export default {
    props: ["hide_challenge"],
    data() {
        return {
            search: "",

        };
    },
    watch: {

        search() {
            this.$store.commit("setSearchFilters", this.search);
        },
    },
    computed: {
        items_challenge() {
            return [
                {
                    title: "Tous",
                    value: "Tous",
                },
                {
                    title: "12 boucles",
                    value: "Challenge 12 boucles",
                },
                {
                    title: "12 boucles relai",
                    value: "Challenge 12 boucles relai",
                },
            ];
        },
    },
};
</script>

<style lang="scss" scoped></style>